import React from 'react';
import { Link } from 'react-router-dom';
import { SiteFooterBar } from '../styles/policyStyles';

function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <SiteFooterBar>
      <nav>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/support">Support</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <a href="mailto:support@onmyway.city">support@onmyway.city</a>
      </nav>
      <div>© {year} Dehors Tech Pty Ltd.</div>
    </SiteFooterBar>
  );
}

export default SiteFooter;
